import React, {useState} from "react";

function HoverImage({className, imageA, imageB}) {
    const [hover, setHover] = useState(false);

    return (
        <div className='place-center' onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            {hover && <img className={className} src={imageB} alt="" /> }
            {!hover && <img className={className} src={imageA} alt="" /> }
        </div>
    );
}

export default HoverImage;